import React from 'react'
import LoginForm from '../../Components/Auth/LoginForm'

const Login = () => {
    return (
        <>
            <LoginForm />
        </>
    )
}

export default Login